// extracted by mini-css-extract-plugin
export default {"tableHeader":"SupplierPalletsPickUpsTable_tableHeader__Frud6"};